import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
	InputWrapper,
	InputError,
	InputGroupWrapper,
	SelectExtended,
	TextInputExtended,
} from 'src/components';
import { useOnlyLettersControl } from 'src/components/inputs/use-only-letters-control';
import { OneFormState } from 'src/types';

interface Props {
	paddingTop?: string;
	paddingBottom?: string;
}

export const DireccionCompleta = (props: Props) => {
	const { register } = useFormContext();
	const { formData, formInfo } = useSelector((state: OneFormState) => state);
	const { fields } = formData;

	const roadOptions = [
		{
			code: 'AUTOP',
			name: 'Autopista',
		},
		{
			code: 'AUTOV',
			name: 'Autovía',
		},
		{
			code: 'AVENI',
			name: 'Avenida',
		},
		{
			code: 'BARIO',
			name: 'Barrio',
		},
		{
			code: 'CALLE',
			name: 'Calle',
		},
		{
			code: 'CAMIN',
			name: 'Camino',
		},
		{
			code: 'CARRT',
			name: 'Carretera',
		},
		{
			code: 'GRANV',
			name: 'Gran vía',
		},
		{
			code: 'PASAJ',
			name: 'Pasaje',
		},
		{
			code: 'PASEO',
			name: 'Paseo',
		},
		{
			code: 'PLAYA',
			name: 'Playa',
		},
		{
			code: 'RAMBL',
			name: 'Rambla',
		},
		{
			code: 'RONDA',
			name: 'Ronda',
		},
		{
			code: 'TRAVE',
			name: 'Travesía',
		},
		{
			code: 'URBAN',
			name: 'Urbanización',
		},
		{
			code: 'VIA',
			name: 'Vía',
		},
	];

	// Tipo de vía
	const [tipoVia, setTipoVia] = useState('Autopista');
	function handleChangeTipoVia(event: any) {
		const newTipoVia = event.currentTarget.value;
		setTipoVia(newTipoVia);
	}
	useEffect(() => {
		if (fields.tipoVia) {
			setTipoVia(fields.tipoVia);
		}
	}, []);

	// Nombre
	const [nombreVia, setNombreVia] = useState('');
	const [pristineNombreVia, setPristineNombreVia] = useState(true);
	const { error, regExp } = useOnlyLettersControl(
		pristineNombreVia,
		nombreVia,
	);
	const numberRegExp = /\d|[sS]\/[nN]/gi;
	const handleChangeNombreVia = (e: any) => {
		setNombreVia(e.target.value);
		setPristineNombreVia(false);
	};
	useEffect(() => {
		if (fields.nombreVia) {
			setNombreVia(fields.nombreVia);
		}
	}, []);

	// Número
	const [numeroVia, setNumeroVia] = useState('');
	const [pristineNumeroVia, setPristineNumeroVia] = useState(true);
	const [numeroViaError, setNumeroViaError] = useState(false);
	const regExpNonDigit = /\D/;
	const handleChangeNumber = (e: any) => {
		setNumeroVia(e.target.value);
		if (
			regExpNonDigit.test(e.target.value) ||
			(numeroVia.length > 1 && numeroVia.length < 8)
		) {
			setNumeroViaError(true);
		} else if (numeroVia === 's/n') {
			setNumeroViaError(true);
		}
		setNumeroViaError(false);
		setPristineNumeroVia(false);
	};
	useEffect(() => {
		if (fields.numeroVia) {
			setNumeroVia(fields.numeroVia);
		}
	}, []);

	// Piso y puerta
	const [pisoPuerta, setPisoPuerta] = useState('');
	const handleChangePisoPuerta = (e: any) => {
		setPisoPuerta(e.target.value);
	};
	useEffect(() => {
		if (fields.pisoPuerta) {
			setPisoPuerta(fields.pisoPuerta);
		}
	}, []);

	return (
		<InputGroupWrapper className="direccion_completa-wrapper">
			<InputWrapper
				className="tipo_via-input-wrapper"
				notALayer={formInfo.notALayer}
				{...props}
			>
				<SelectExtended
					options={roadOptions}
					name="typeOfRoad"
					label="Tipo de vía"
					isRequired={true}
					value={tipoVia}
					onClick={() => {}}
					setOption={setTipoVia}
					handleChange={handleChangeTipoVia}
					updateFields
				/>
			</InputWrapper>
			<InputWrapper
				className="nombre_via-input-wrapper"
				notALayer={formInfo.notALayer}
				{...props}
			>
				<TextInputExtended
					name="nombreVia"
					label="Nombre de la vía"
					isFloating
					innerRef={register({
						required: {
							value: true,
							message: 'Requerido',
						},
						pattern: {
							value: regExp,
							message: 'Solo se aceptan letras',
						},
					})}
					onChange={e => handleChangeNombreVia(e)}
					required
				/>
				{error && (
					<InputError className="input-error">
						Solo se aceptan letras
					</InputError>
				)}
			</InputWrapper>
			<InputWrapper
				className="numero_via-input-wrapper"
				notALayer={formInfo.notALayer}
				paddingTop={props.paddingTop}
				paddingBottom={props.paddingBottom}
			>
				<TextInputExtended
					name="numeroVia"
					label="Número"
					isFloating
					innerRef={register({
						required: {
							value: true,
							message: 'Requerido',
						},
						// pattern: {
						//   value: numberRegExp,
						//   message: 'Solo se aceptan números',
						// },
					})}
					onChange={e => handleChangeNumber(e)}
					required
				/>
				{numeroViaError && (
					<InputError className="input-error">
						Se aceptan números o la expresión s/n
					</InputError>
				)}
			</InputWrapper>
			<InputWrapper
				className="piso_puerta-input-wrapper"
				notALayer={formInfo.notALayer}
				paddingTop={props.paddingTop}
				paddingBottom={props.paddingBottom}
			>
				<TextInputExtended
					name="pisoPuerta"
					label="Piso y puerta"
					isFloating
					onChange={e => handleChangePisoPuerta(e)}
				/>
			</InputWrapper>
		</InputGroupWrapper>
	);
};
